export const CATEGORIES = {
  CANCELLED: {
    key: "CANCELLED",
    label: "Order",
    tint: "#FDEEEC",
    color: "#EF3E32",
    keywords: ["CANCEL", "DECLIN", "REJECT", "FAIL", "RETURN"],
  },
  REFUND: {
    key: "REFUND",
    label: "Refund",
    tint: "#E6F5EE",
    color: "#0E8A5F",
    keywords: ["REFUND"],
  },
  PAYMENT: {
    key: "PAYMENT",
    label: "Payment",
    tint: "#E6F5EE",
    color: "#0E8A5F",
    keywords: ["PAYMENT", "PAID", "CHARGED", "RECEIPT", "INVOICE"],
  },
  DISPATCHED: {
    key: "DISPATCHED",
    label: "Delivery",
    tint: "#EAF2FA",
    color: "#2A6FB0",
    keywords: ["OUT FOR DELIVERY", "DISPATCH", "SHIPPED", "TRANSIT", "ON THE WAY"],
  },
  DELIVERED: {
    key: "DELIVERED",
    label: "Delivery",
    tint: "#EFF7E4",
    color: "#4B8B1E",
    keywords: ["DELIVERED", "COMPLETED", "FULFILLED"],
  },
  ORDER_CONFIRMED: {
    key: "ORDER_CONFIRMED",
    label: "Order",
    tint: "#EFF7E4",
    color: "#4B8B1E",
    keywords: ["CONFIRM", "ACCEPT", "APPROVE"],
  },
  REVIEW: {
    key: "REVIEW",
    label: "Review",
    tint: "#FFF5DE",
    color: "#E0A21C",
    keywords: ["REVIEW", "RATING", "RATE YOUR", "FEEDBACK"],
  },
  PROMO: {
    key: "PROMO",
    label: "Offer",
    tint: "#FDECF2",
    color: "#D24C7A",
    keywords: ["PROMO", "OFFER", "DISCOUNT", "% OFF", "DEAL", "COUPON", "SALE"],
  },
  PENDING: {
    key: "PENDING",
    label: "Order",
    tint: "#FBF2E6",
    color: "#AE6F28",
    keywords: ["PENDING", "AWAIT", "PROCESSING"],
  },
  ORDER_PLACED: {
    key: "ORDER_PLACED",
    label: "Order",
    tint: "#FBF2E6",
    color: "#AE6F28",
    keywords: ["PLACED", "CREATED", "ORDER"],
  },
  GENERAL: {
    key: "GENERAL",
    label: "Update",
    tint: "#F4EFE9",
    color: "#7A6A5B",
    keywords: [],
  },
};

export const CATEGORY_ORDER = [
  "CANCELLED",
  "REFUND",
  "PAYMENT",
  "DISPATCHED",
  "DELIVERED",
  "ORDER_CONFIRMED",
  "REVIEW",
  "PROMO",
  "PENDING",
  "ORDER_PLACED",
];

export const TONES = {
  DANGER: ["CANCEL", "DECLIN", "REJECT", "FAIL"],
  SUCCESS: ["DELIVERED", "COMPLETED", "CONFIRM", "PAID", "PAYMENT", "REFUND", "ACCEPT"],
  WARNING: ["PENDING", "AWAIT", "PROCESSING", "DELAY"],
};

export const resolveCategory = (statusKey, title) => {
  const haystack = `${statusKey || ""} ${title || ""}`.toUpperCase();

  const match = CATEGORY_ORDER.find((key) =>
    CATEGORIES[key].keywords.some((word) => haystack.includes(word))
  );

  return CATEGORIES[match || "GENERAL"];
};

export const resolveTone = (statusKey) => {
  const key = (statusKey || "").toUpperCase();

  const match = Object.keys(TONES).find((tone) =>
    TONES[tone].some((word) => key.includes(word))
  );

  return match || "INFO";
};
